import { render, staticRenderFns } from "./SwitchScenic.vue?vue&type=template&id=4eaa69b1&scoped=true&"
import script from "./SwitchScenic.vue?vue&type=script&lang=js&"
export * from "./SwitchScenic.vue?vue&type=script&lang=js&"
import style0 from "./SwitchScenic.vue?vue&type=style&index=0&id=4eaa69b1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eaa69b1",
  null
  
)

export default component.exports